<template>
  <div>
    <b-navbar variant="yellow" class="v-25 text-yellow"> asg </b-navbar>
    <div class="container">
      <b-row>
        <b-col xs="12" sm="12" md="12" lg="12" xl="2" cols="12" />
        <b-col xs="12" sm="12" md="12" lg="12" xl="8" cols="12">
          <b-form class="m-4" @submit.stop.prevent="save">
            <h2 class="text-purple-yellow">Sign up</h2>
            <b-row>
              <b-col xs="12" sm="12" md="6" lg="6" xl="6" cols="12">
                <!-- Company name -->
                <b-form-group label-size="sm">
                  <template slot="label">
                    Company name <span class="text-danger"> *</span>
                  </template>
                  <b-form-input
                    id="companyName-input"
                    v-model.trim="$v.form.companyName.$model"
                    size="sm"
                    name="companyName-input"
                    :value="form.companyName"
                    :state="validateState('companyName')"
                    aria-describedby="input-companyName-live-feedback"
                    :maxlength="65"
                    @change="setValue('companyName', $event)"
                  />
                  <b-form-invalid-feedback id="input-companyName-live-feedback">
                    This is a required field and must at least 2 characters.
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col sm="12" md="6" lg="6" xl="6">
                <!-- Email -->
                <b-form-group label-size="sm">
                  <template slot="label">
                    Email <span class="text-danger"> *</span>
                  </template>
                  <b-form-input
                    id="email-input"
                    v-model.trim="$v.form.email.$model"
                    size="sm"
                    name="email-input"
                    :formatter="lowerCaseFormatter"
                    :value="form.email"
                    :state="validateState('email')"
                    aria-describedby="input-email-live-feedback"
                    maxlength="255"
                    @change="setValue('email', $event)"
                  />
                  <b-form-invalid-feedback id="input-email-live-feedback">
                    This is a required field and must be a valid email.
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col xs="12" sm="12" md="6" lg="6" xl="6" cols="12">
                <!-- First name -->
                <b-form-group label-size="sm">
                  <template slot="label">
                    First name <span class="text-danger">*</span>
                  </template>
                  <b-form-input
                    id="firstName-input"
                    v-model.trim="$v.form.name.$model"
                    size="sm"
                    name="firstName-input"
                    :value="form.name"
                    :state="validateState('name')"
                    aria-describedby="input-firstName-live-feedback"
                    maxlength="100"
                    @change="setValue('name', $event)"
                  />
                  <b-form-invalid-feedback id="input-firstName-live-feedback">
                    This is a required field and must at least 2 characters.
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col xs="12" sm="12" md="6" lg="6" xl="6">
                <!-- Last name -->
                <b-form-group label-size="sm">
                  <template slot="label">
                    Last name <span class="text-danger">*</span>
                  </template>
                  <b-form-input
                    id="lastName-input"
                    v-model.trim="$v.form.lastName.$model"
                    size="sm"
                    name="lastName-input"
                    :value="form.lastName"
                    :state="validateState('lastName')"
                    aria-describedby="input-lastName-live-feedback"
                    maxlength="100"
                    @change="setValue('lastName', $event)"
                  />
                  <b-form-invalid-feedback id="input-lastName-live-feedback">
                    This is a required field and must at least 2 characters.
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12" md="6" lg="6" xl="6">
                <!-- Office phone number -->
                <b-form-group label-size="sm">
                  <template slot="label">
                    Office phone number <span class="text-danger">*</span>
                  </template>
                  <b-input-group>
                    <vue-tel-input
                      v-model.trim="$v.form.officePhoneNumber.$model"
                      default-country="us"
                      :input-options="options"
                      :dropdown-options="telDdOptions"
                      :auto-format="true"
                      :valid-characters-only="true"
                      mode="international"
                      style-classes="z-index-2"
                      :value="form.officePhoneNumber"
                      class="w-75"
                      @change="setValue('officePhoneNumber', $event)"
                    />
                    <b-form-input
                      id="extension-input"
                      v-model.trim="$v.form.extension.$model"
                      size="md"
                      type="tel"
                      maxlength="6"
                      max="999999"
                      onkeydown="javascript: return event.keyCode == 69 ? false : true"
                      class="append-input"
                      placeholder="ext"
                      name="extension-input"
                      :value="form.extension"
                      :state="validateState('extension')"
                      @change="setValue('extension', $event)"
                    />
                    <b-form-invalid-feedback />
                    <b-form-invalid-feedback>
                      This is a required field
                    </b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col sm="12" md="6" lg="6" xl="6">
                <!-- Mobile phone -->
                <b-form-group label-size="sm" label="Mobile phone">
                  <template slot="label"> Mobile phone </template>
                  <vue-tel-input
                    v-model="form.mobilePhone"
                    default-country="us"
                    :input-options="options"
                    :dropdown-options="telDdOptions"
                    :auto-format="true"
                    :valid-characters-only="true"
                    :value="form.mobilePhone"
                    mode="international"
                    style-classes="z-index-2"
                    @change="
                      setValue('mobilePhone', $event);
                      handleMobilePhoneChange();
                    "
                  />

                  <b-form-invalid-feedback
                    id="input-mobile-phone-live-feedback"
                  >
                    This is a numeric field
                  </b-form-invalid-feedback>
                  <!--    <b-alert show variant="info" class="mt-2 text-justify">
                    <small>
                      Mobile Phone will be used for notifications.
                      <br />
                      You may opt-out from receiving SMS messages at any time by
                      removing your mobile phone from your profile.
                    </small>
                  </b-alert> -->
                </b-form-group>
              </b-col>
            </b-row>
            <b-row />
            <b-row>
              <b-col sm="12" md="6" lg="12" xl="12">
                <b-form-checkbox
                  id="checkbox-3"
                  v-model="isAccepTerms"
                  class="z-index-0 mb-2"
                  name="checkbox-3"
                  :value="true"
                  :unchecked-value="false"
                >
                  I accept the
                  <a v-b-modal.terms-modal href="#"> terms and conditions</a>
                  and I have read the
                  <a v-b-modal.messaging-policy-modal href="#">
                    Messaging Policy
                  </a>
                </b-form-checkbox>
                <b-form-checkbox
                  id="checkbox-1"
                  v-model="isAcceptEmailNotifications"
                  class="z-index-0 mb-2"
                  name="checkbox-2"
                  :value="true"
                  :unchecked-value="false"
                >
                  I wish to receive notifications via Email from
                  <a href="https://dashboard.transcanauto.com/#/"
                    >Transcanauto.com</a
                  >
                </b-form-checkbox>
                <b-form-checkbox
                  id="checkbox-2"
                  v-model="isAcceptSmsNotifications"
                  :disabled="form.mobilePhone.length < 12"
                  class="z-index-0"
                  name="checkbox-2"
                  :value="true"
                  :unchecked-value="false"
                >
                  I wish to receive notifications via SMS from
                  <a href="https://dashboard.transcanauto.com/#/"
                    >Transcanauto.com</a
                  >
                </b-form-checkbox>
              </b-col>
              <b-col sm="12" md="3" lg="3" xl="3" />
            </b-row>
            <b-row class="mt-3">
              <b-col sm="12" md="4" lg="4" xl="4" />
              <b-col sm="12" md="4" lg="4" xl="4">
                <b-btn
                  block
                  size="lg"
                  class="btn btn-success"
                  :disabled="
                    $v.form.$invalid ||
                    isLoading ||
                    !isAccepTerms ||
                    (!isAcceptEmailNotifications && !isAcceptSmsNotifications)
                  "
                  type="submit"
                >
                  <b-spinner v-if="isLoading" small variant="white" />
                  <span v-else>Submit</span>
                </b-btn>
              </b-col>
              <b-col sm="12" md="4" lg="4" xl="4" />
            </b-row>
            <b-row class="mt-3">
              <p class="text-justify">
                <small style="color: gray">
                  By clicking “Submit”, you agree to transcanauto.com and/or
                  Trans Canada Auto Terms of Use and Privacy Policy. You consent
                  to receive phone calls and SMS messages from transcanauto.com
                  and/or Trans Canada Auto to provide updates on your order
                  and/or for marketing purposes. Message frequency depends on
                  your activity. You may opt-out by texting “STOP”. Message and
                  data rates may apply.
                </small>
              </p>
            </b-row>

            <b-row>
              <b-col class="text-center">
                <br />
                <hr />
                <small style="color: gray">
                  Trans Canada AUTO 4266 DOVE RD. SUITE C PORT HURON 48060
                  MICHIGAN
                  <a href="tel: +1 833 396 1906"> +1 833 396 1906 </a>
                </small>
              </b-col>
            </b-row>
          </b-form>
        </b-col>
        <b-col xs="12" sm="12" md="12" lg="12" xl="2" cols="12" class="" />
      </b-row>

      <b-modal
        id="emailModal"
        ref="emailModal"
        centered
        size="md"
        hide-header-close
        hide-header
        hide-footer
        body-class="pl-0 pr-0"
      >
        <div class="text-center p-5">
          <p>
            <b-icon font-scale="5" icon="envelope" />
          </p>
          <h5>We sent a confirmation link to the email address entered</h5>
          <b-btn
            size="lg"
            class="btn-main mt-2"
            @click="
              $bvModal.hide('emailModal');
              goTo();
            "
          >
            Accept
          </b-btn>
        </div>
      </b-modal>

      <TermsAndConditions />
      <MessagingPolicy />
    </div>
  </div>
</template>

<script>
import { required, minLength, email, numeric } from "vuelidate/lib/validators";
import { POST_EMAIL_VALIDATION, POST_USER } from "./actions";
import { mapState } from "vuex";
import TermsAndConditions from "./components/TermsAndConditions";
import MessagingPolicy from "./components/MessagingPolicy";

export default {
  components: { TermsAndConditions, MessagingPolicy },
  computed: {
    ...mapState({
      emailValidation: (state) => state.buyer.buyerStore.emailValidation.data,
      user: (state) => state.buyer.buyerStore.user,
    }),
    isLoading() {
      return this.user.status == "fetching" ? true : false;
    },
    mobileNumberHandle() {
      return this.form.mobilePhone;
    },
  },
  watch: {
    mobileNumberHandle: function () {
      if (this.mobileNumberHandle == "") {
        this.isAcceptSmsNotifications = false;
      }
    },
  },
  data() {
    return {
      status: false,
      isAccepTerms: false,
      isAcceptEmailNotifications: false,
      isAcceptSmsNotifications: false,
      form: {
        name: null,
        lastName: null,
        email: null,
        officePhoneNumber: null,
        extension: null,
        mobilePhone: "",
        companyName: null,
      },
      options: {
        type: "tel",
        validCharactersOnly: true,
        maxlength: 14,
      },
      telDdOptions: {
        showDialCodeInList: true,
        showFlags: true,
        showDialCodeInSelection: false,
      },
    };
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(2),
      },
      lastName: {
        required,
        minLength: minLength(2),
      },
      email: {
        required,
        email,
      },
      extension: {
        numeric,
      },
      officePhoneNumber: {
        required,
        minLength: minLength(10),
      },
      companyName: {
        required,
      },
    },
  },
  mounted() {},
  methods: {
    setValue(key, value) {
      this.form[key] = value;
      this.$v.form[key].$touch();
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    async save() {
      await this.verifyEmail();
      if (this.emailValidation.message === "invalid email") {
        return;
      }
      const payload = this.formatPayload();
      this.$store
        .dispatch(POST_USER, payload)
        .then(() => {
          this.$refs["emailModal"].show();
        })
        .catch(() => {
          this.$root.$bvToast.toast(this.user.error.response.data.message, {
            title: "Warning",
            variant: "warning",
          });
        });
    },
    async verifyEmail() {
      await this.$store
        .dispatch(POST_EMAIL_VALIDATION, this.form)
        .then(() => {
          if (this.emailValidation.message === "invalid email") {
            this.$root.$bvToast.toast("This email has already been taken", {
              title: "Warning",
              variant: "warning",
            });
          }
        })
        .catch(() => {
          this.$root.$bvToast.toast("error", {
            title: "Error",
            variant: "warning",
          });
        });
    },
    goTo() {
      this.$router.push({ path: "/" });
    },
    formatPayload() {
      let role = 3; // ROLE_CLIENT

      const payload = {
        firstName: this.form.name,
        lastName: this.form.lastName,
        email: this.form.email,
        rolesId: [role],
        userDetails: {
          extension: this.form.extension,
          mobileNumber: this.form.mobilePhone,
          officePhoneNumber: this.form.officePhoneNumber,
          acceptEmail: this.isAcceptEmailNotifications,
          acceptSms: this.isAcceptSmsNotifications,
        },
        company: {
          companyName: this.form.companyName,
        },
      };

      return payload;
    },
  },
};
</script>

<style scoped>
.append-input {
  max-width: 40%;
}
</style>
